const MuiTableRow = {
    styleOverrides: {
        hover: {
            cursor: 'pointer'
        }
    }
};
export { MuiTableRow };

//# sourceMappingURL=table-row.js.map